// extracted by mini-css-extract-plugin
module.exports = {"detail":"styles_detail__3PON8","time":"styles_time__5j6Zc"};